exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  background-color: white;\n  text-align: right; }\n", ""]);

// exports
